import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { discountEditorSelectors } from 'redux/modules/DiscountEditor';
import { useAppSelector, useAppDispatch } from 'redux/hooks';
import { alertSelectors } from 'redux/modules/Alert';
import { resetDiscountEditor } from 'redux/modules/DiscountEditor/discountEditor';
import { ROUTES } from 'config';
import {
  closeButtonClick,
  closeLogoPopUp,
  showLogoPopUp,
} from 'redux/modules/Alert/alert';
import { Icon } from 'view/atoms';
import { PopupConfirm } from 'view/molecules/PopupConfirm';
import andersenLogo from 'static/icons/andersenLogo.svg';
import springMainLogo from 'static/icons/andersenSpringLogo.svg';
import summerMainLogo from 'static/icons/andersenSummerLogo.svg';
import fallMainLogo from 'static/icons/andersenFallLogo.svg';
import winterMainLogo from 'static/icons/andersenWinterLogo.svg';
import { getCurrentSeason } from 'utils';
import * as S from './Logo.styles';

type LogoProps = {
  isFooter?: boolean;
};

export const Logo = ({ isFooter = false }: LogoProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const season = getCurrentSeason();
  const seasonalLogoMap = {
    spring: springMainLogo,
    summer: summerMainLogo,
    fall: fallMainLogo,
    winter: winterMainLogo,
  };
  const seasonalLogo = seasonalLogoMap[season];
  const seasonalLogoAlt = `Andersen ${season} logo`;

  const dispatch = useAppDispatch();

  const discountCountry = useAppSelector(
    discountEditorSelectors.getDiscountCountry,
  );

  const warning = useAppSelector(discountEditorSelectors.getWarning);
  const isDiscountFirstStepNotEmpty = () => {
    return pathname === ROUTES.discountEditor && discountCountry?.countryName;
  };

  const isLogoPopUpOpen = useAppSelector(alertSelectors.isLogoPopUpOpen);

  const clickHandler = () => {
    if (pathname === ROUTES.location) return;

    if (isDiscountFirstStepNotEmpty()) {
      dispatch(showLogoPopUp());
    } else {
      navigate(ROUTES.main, { state: { isLogoClicked: true } });
    }
  };

  const togglePopUp = () => {
    dispatch(closeLogoPopUp());
  };

  const onConfirmHandler = () => {
    navigate(ROUTES.main);
    togglePopUp();
    dispatch(resetDiscountEditor());
  };

  const onCancelHandler = () => {
    navigate(pathname);
    if (warning?.existingDiscountID) {
      dispatch(closeButtonClick());
    }
    togglePopUp();
  };

  return (
    <>
      <S.LogoStyled isFooter={isFooter} $season={season} onClick={clickHandler}>
        <Icon src={andersenLogo} alt="Andersen's logo" />
        <Icon
          src={seasonalLogo}
          alt={seasonalLogoAlt}
          className='hat-img'
        />
        <S.LogoText isFooter={isFooter}>A-BENEFITS</S.LogoText>
      </S.LogoStyled>

      {isLogoPopUpOpen && (
        <PopupConfirm
          closeHandler={onCancelHandler}
          confirmHandler={onConfirmHandler}
          title={t('discountLeavingPopup.title')}
          description={t('discountLeavingPopup.description')}
          yesText={t('discountLeavingPopup.confirm')}
          cancelText={t('other.cancel')}
        />
      )}
    </>
  );
};
